import { s_r_e as lang } from '~/lang/ru';
import { RadioBlock } from '~/components/RadioBlock';
import { map } from 'ramda';
import store from './store/request';
import { ActView } from './ActView';

/** @enum */
export const Disposition = {
	Client: 'CLIENT',
	Asc: 'ASC',
}

/** @enum */
export const DispositionName = {
	[Disposition.Client]: lang('ACT_GIVEN_TO_THE_CLIENT'),
	[Disposition.Asc]: lang('ACT_LEFT_IN_SERVICE_CENTER'),
}

export const ActConfirm = {
	name: 'ActConfirm',
	props: {
		act: Object,
	},
	data: () => ({
		formType: null,
	}),
	render() {
		return (
			<form method="post">
				<input type="hidden" name="form" value="actConfirm" />
				<input type="hidden" name="ACT_ID" value={ this.act.id } />

				<ActView act={ this.act } />

				<div class="mb-4">
					{ map((option) => {
						const isSelected = option.value === this.formType;

						return (
							<label class={[
								'button button_theme_secondary-ghost button_size_s mr-4',
								{ 'active': isSelected }
							]}>
								<input
									class="hidden"
									type="radio"
									name="FORM_TYPE"
									value={ option.value }
									selected={ isSelected }
									onChange={ () => this.formType = option.value }
								/>
								{ option.text }
							</label>
						)
					}, store.actForms) }
				</div>

				<div class="mb-6">
					{ Object.entries(DispositionName).map(([value, text]) => (
						<RadioBlock
							label={ text }
							class="mb-2"
							name="DISPOSITION"
							value={ value }
							required
							checked={ this.act.disposition === value }
						/>
					)) }
				</div>

				<button class="button button_theme_secondary">
					{ lang('CONFIRM') }
				</button>
			</form>
		);
	},
}
